/* unplugin-vue-components disabled */import { render } from "./upfile.vue?vue&type=template&id=57cb753c&scoped=true"
import script from "./upfile.vue?vue&type=script&lang=js"
export * from "./upfile.vue?vue&type=script&lang=js"

import "./upfile.vue?vue&type=style&index=0&id=57cb753c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cb753c"]])

export default __exports__